import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from 'src/app/core/common';
import { PersianDate } from 'src/app/core/persian-date';
import { LocationService } from 'src/app/services/location.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.scss']
})
export class AgentListComponent implements OnInit {
  constructor(private userService: UserService, private spinner: SpinnerService, private locationService: LocationService,
    private sharedService: SharedService, private route: ActivatedRoute, private router: Router) { }
  Utility = Utility;

  params: any = {};
  title: string;

  users: any[];
  total: number;
  criteria: any = {};
  states: string[];
  counts: any = {};
  searching: boolean;

  async ngOnInit() {
    const cities = await this.locationService.getCities();
    this.counts = await this.userService.countAgentsFilter();
    this.states = Utility.distinct(cities, 'State').sort((a, b) => this.counts[b] - this.counts[a]);

    await new Promise<void>(resolve => {
      this.route.params.subscribe(async params => {
        this.spinner.show();

        this.params = Object.assign({}, params);
        if (!this.params.l) { delete this.params.l; }
        if (!this.params.q) { delete this.params.q; }

        this.title = `جستجوی کاریابی‌ ${params.q || ''}`;
        if (this.params.l) {
          const parts = params.l.split('،').filter(_ => _);
          this.criteria.State = parts[0];
          this.criteria.City = parts[1];
          this.title += ' در ' + (this.criteria.City ? 'شهر ' + this.criteria.City : 'استان ' + this.criteria.State);
        } else {
          delete this.criteria.State;
          delete this.criteria.City;
        }
        this.criteria.Keyword = this.params.q;

        this.searching = params.l || params.q;
        if (this.searching) {
          this.searching = true;
          const result = await this.userService.searchAgent({ Agent: this.criteria }, 0, 100);
          this.users = result?.users;
          this.total = result?.total;
        }

        this.spinner.hide();

        this.seo();

        resolve();
      });
    });
  }

  setLocation(location: string) {
    this.params.l = this.params.l == location ? '' : location;
    this.router.navigate(['/agent', this.params]);
  }

  private seo() {
    this.sharedService.setTitle(this.title);
    this.sharedService.setDescriptionMeta(`جستجو در ${this.title}`);
    this.sharedService.setKeywordsMeta(this.params.q, this.params.l);
  }

  hasDate(date: any) { return new PersianDate(date).year > 0; }
}
